import { Construtor } from './construtor';

export class FiltroReincidencia implements Construtor<FiltroReincidencia> {

  public idCliente: number;
  public idUsuario: number[];
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;

  constructor(object?: any) {

    this.idUsuario = new Array<number>();

    if (object !== undefined) {

      if (object instanceof FiltroReincidencia) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  copyObject(inconsistencia: FiltroReincidencia): void {
    this.idCliente = inconsistencia.idCliente;
    this.idUsuario = inconsistencia.idUsuario;
    this.dataInicioReferencia = inconsistencia.dataInicioReferencia;
    this.dataFimReferencia = inconsistencia.dataFimReferencia;
  }

  parseFromJson(inconsistencia: any): void {
    this.idCliente = inconsistencia.idCliente;
    this.idUsuario = inconsistencia.idUsuario;
    this.dataInicioReferencia = inconsistencia.dataInicioReferencia;
    this.dataFimReferencia = inconsistencia.dataFimReferencia;
  }

  modeloCompleto(): boolean {
    return this.idCliente !== undefined &&
      this.idUsuario !== undefined;
  }

  getNewInstance(object?: any): FiltroReincidencia {
    return new FiltroReincidencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/filtro-reincidencia.ts